export default {
  copy: {
    label: 'Copy',
    keys: ['super+c'],
    default: false,
    desc: 'Copies the currently selected elements'
  },
  cut: {
    label: 'Cut',
    keys: ['super+x'],
    default: false,
    desc: 'Cuts the currently selected elements'
  },
  paste: {
    label: 'Paste',
    keys: ['super+v'],
    default: false,
    desc: 'Paste the clipboard',
  },
  delete: {
    label: 'Delete',
    keys: ['backspace', 'delete'],
    default: true,
    desc: 'Delete the current selection'
  },
  move: {
    label: 'Move selection',
    keys: ['up', 'down', 'left', 'right'],
    default: true,
    desc: 'Moves the current selection'
  },
  move5: {
    label: 'Move selection more',
    keys: ['shift+up', 'shift+left', 'shift+down', 'shift+right'],
    default: true,
    desc: 'Moves the current selection 5px'
  },
};
